<template>
    <section :class="{container : jsondata != null}" class="contentPsdding">
        <modal v-if="moreKeysInfo" @off="moreKeysInfo = !moreKeysInfo">
            <h5>
               {{ keyItem.name[lang()] }}
            </h5>
            <img :src="keyItem.image" alt="som img" style="width: 30%;">
            <p>{{ keyItem.text[lang()] }}</p>
            <a :href="keyItem.url" target="_blanck" class="btn services-custom-button">{{ casesWatchProject[lang()] }}</a>
        </modal>
        <div class="row" v-if="jsondata != null">
            <template v-for="(item, index) in jsondata">
                <div :key="index" class="col-md-3 keyDiv" @click="getMoreInfo(item)">
                    <div class="divKeiItem">
                        <h6>{{ item.name[lang()] }}</h6>
                        <img :src="item.image" alt="img" class="keyImg">
                    </div>
                </div>
            </template>
        </div>
        <div  class="keyNoConnect" v-else>
            <b-spinner label="Spinning" style="color: #263238"></b-spinner>
        </div>
    </section>
</template>

<script>
import { store } from '../store.js';
import modal from './modal.vue';
export default {
  data () {
    return {
      keyItem: null,
      moreKeysInfo: false
    }
  },
  created() {

  },
  methods: {
    lang() {
      return localStorage.getItem('lang');
    },
    getMoreInfo(item) {
      this.keyItem = item;
      this.moreKeysInfo = !this.moreKeysInfo;
    },
  },
  components: {
    modal
  },
  computed: {
    jsondata() {
        return store.getStart.cases_data
    },
    casesWatchProject() {
        return store.casesWatchProject
    }
  }
}
</script>

<style>
    .keyDiv {
        text-align: center;
        cursor: pointer;
        padding: 1rem;
    }
    .keyImg{
        width: 100%;
        transition: 0.5s;
    }
    .keyNoConnect {
        width: 100vw;
        height: calc(100vh - 10vh);
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .divKeiItem {
        /*border: 1px solid #eaeaea;*/
        box-shadow: 0 0 10px #FF497A, 0 0 20px #511B75;
        padding: 5px;
        border-radius: 0.2rem;
        /*background: #eaeaea;*/
        background-color: rgba(13, 14, 44, 0.95);
    }
    .divKeiItem:hover > img {
        transform: scale(0.9);
    }
    .contentPsdding {
        padding-bottom: 5vh;
    }
</style>



// WEBPACK FOOTER //
// src/components/Keys.vue